import { apiOptions, apiRequest } from "../../utils";
import { API_V3 } from "../../constants";

export const propertySectionCategoryService = {
  getAll: async ({ filters, sort, params, signal } = {}) => {
    const options = await apiOptions({
      url: `${API_V3}/propertysectioncategories`,
      method: "get",
      signal,
      params,
      filters,
      sort,
    });

    return apiRequest(options);
  },

  get: async (id) => {
    const options = await apiOptions({
      url: `${API_V3}/propertysectioncategories/${id}`,
      method: "get",
    });

    return apiRequest(options);
  },

  create: async (request) => {
    const options = await apiOptions({
      url: `${API_V3}/propertysectioncategories`,
      method: "post",
      data: request,
    });

    const toastMessageConfig = {
      failure: {
        message: "Failure saving area category",
      },
      success: {
        message: "Area category saved successfully",
      },
    };
    return apiRequest(options, toastMessageConfig);
  },

  update: async (id, request) => {
    const options = await apiOptions({
      url: `${API_V3}/propertysectioncategories/${id}`,
      method: "post",
      data: request,
    });

    const toastMessageConfig = {
      failure: {
        message: "Failure saving area category",
      },
      success: {
        message: "Area category saved successfully",
      },
    };
    return apiRequest(options, toastMessageConfig);
  },

  delete: async ({ id }) => {
    const options = await apiOptions({
      url: `${API_V3}/propertysectioncategories/${id}`,
      method: "delete",
    });
    const toastMessageConfig = {
      success: {
        message: "Area category deleted successfully",
      },
    };

    return apiRequest(options, toastMessageConfig);
  },
};
